import * as XLSX from 'xlsx'
import type { EditableCard } from './scan-card-types'

// Generate Excel file from scanned card data for bulk import
export const generateExcel = (data: EditableCard[]): File => {
    const rows = data.map((c) => ({
        customer_name: c.customer_name,
        customer_email: c.customer_email,
        customer_phone: c.customer_phone,
        customer_position: c.customer_position,
        customer_industry: c.customer_industry,
        customer_website: c.customer_website,
        customer_note: c.customer_note,
        company_name: c.company_name,
        company_address: c.company_address,
        company_website: c.company_website,
        company_tax: c.company_tax,
        customer_type: c.customer_type,
        customer_source: c.customer_source,
        customer_sale_followers: c.customer_sale_followers.join(','),
    }))
    const ws = XLSX.utils.json_to_sheet(rows)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Customers')
    const buf = XLSX.write(wb, { type: 'array', bookType: 'xlsx' })
    return new File([buf], 'scanned_customers.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
}
